import Button from '@/common/components/base/button/Button';
import MainModal from '@/common/components/base/modal/Modal';
import { MainModalProps } from '@/common/components/base/modal/Modal.type';
import Typography from '@/common/components/base/typography/Typography';
import AlertImg from '@/modules/Dashboard/assets/icons/Alert.svg?react';
import ReleaseImg from '@/modules/Dashboard/assets/icons/Release.svg?react';
import LayerImg from '@/modules/Dashboard/assets/icons/layer.svg?react';
import { Box, Flex } from 'styled-system/jsx';
import { VersionNotificationResponse } from '../../queries/versionNotification/versionNotificationQuery.type';

interface VersionNotificationProps {
  NotificationData?: VersionNotificationResponse;
  closeModal: () => void;
}

export default function VersionNotificationModal({
  open,
  closeModal,
  NotificationData,
}: MainModalProps & { NotificationData?: VersionNotificationResponse }) {
  if (!NotificationData) return null;

  return (
    <MainModal
      closeModal={closeModal}
      open={open}
      title={
        NotificationData?.alert?.type === 'message'
          ? 'نسخه جدید، آماده استفاده'
          : 'اطلاع رسانی'
      }
    >
      <VersionNotification
        closeModal={closeModal}
        NotificationData={NotificationData}
      />
    </MainModal>
  );
}

const VersionNotification = ({
  closeModal,
  NotificationData,
}: VersionNotificationProps) => {
  if (!NotificationData) return null;

  return (
    <Flex direction="column" height="100%" maxHeight="70vh">
      <Box flex="1" overflowY="auto" pb="20px">
        <Box display="flex" flexDirection="row" justifyContent="center" my={34}>
          {NotificationData?.alert?.type === 'message' ? (
            <ReleaseImg />
          ) : (
            <AlertImg />
          )}
        </Box>

        {NotificationData?.alert?.type === 'message' && (
          <Flex gap="10px" alignItems="center" mb={14}>
            <LayerImg />
            <Typography>
              تغییرات نسخه {NotificationData.app_version.last_version}
            </Typography>
          </Flex>
        )}

        <Typography color="black-1" textStyle="b2" mb={30} pr={12}>
          {NotificationData?.alert?.message}
        </Typography>
      </Box>

      <Box pt="16px" bg="white">
        <Button fullWidth onClick={closeModal}>
          متوجه شدم
        </Button>
      </Box>
    </Flex>
  );
};
